












































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import { ActionMethod } from 'vuex';
import { Action, State } from 'vuex-class';
import TakeAway from '@/models/takeAway';
import tokenExtractor from '@/utils/tokenExtractor';
import PageSpinner from '@/components/ui/PageSpinner/index.vue';

enum ProjectTypes {
  GRILL_KEBAB = 'GRILL_KEBAB',
  DONER_TURKISH_GRILL = 'DONER_TURKISH_GRILL',
  GRILL_MANERO = 'GRILL_MANERO',
  DEENERS_KEBAB = 'DEENERS_KEBAB',
  KEBAB_BROTHERS = 'KEBAB_BROTHERS',
  VKUSNIY_KEBAB = 'VKUSNIY_KEBAB',
  MISTER_DONER = 'MISTER_DONER',
  SONIC = 'SONIC',
  DEFAULT = 'DEFAULT',
}

const PLACE_IDS: any = {
  /*'jxD3BkTsYPeq': ProjectTypes.GRILL_KEBAB,*/
  'e0B2cISgjzVf': ProjectTypes.GRILL_KEBAB,
  'LidZ6hYUqLRG': ProjectTypes.GRILL_KEBAB,
  'sX4YyxLf0LEy': ProjectTypes.GRILL_KEBAB,
  'Ct2mbcxefeAG': ProjectTypes.GRILL_KEBAB,
  'bFsxnpnIwA3J': ProjectTypes.GRILL_KEBAB,
  'BeV4PHmmBOnq': ProjectTypes.GRILL_KEBAB,
  'x4WioZp3YOGM': ProjectTypes.DONER_TURKISH_GRILL,
  'ByIJJEPq0kbG': ProjectTypes.GRILL_MANERO,
  'xXXo8qP8Ivqq': ProjectTypes.GRILL_MANERO,
  'ECITUok4KTJD': ProjectTypes.DEENERS_KEBAB,
  'dU4sOKONgk0V': ProjectTypes.VKUSNIY_KEBAB,
  'n1252D5rErRS': ProjectTypes.KEBAB_BROTHERS,
  'Ej2pe6MQSfZZ': ProjectTypes.KEBAB_BROTHERS,
  'bdMragSqYj4o': ProjectTypes.KEBAB_BROTHERS,
  'el8OdqqqevnN': ProjectTypes.KEBAB_BROTHERS,
  'el8Odqqqevn1': ProjectTypes.KEBAB_BROTHERS,
  'el8Odqqqevn2': ProjectTypes.KEBAB_BROTHERS,
  'PEMjcfJo7yX1': ProjectTypes.KEBAB_BROTHERS,
  'k6oTtZFHaTJW': ProjectTypes.MISTER_DONER,
  'MLC6CpQlxm4l': ProjectTypes.SONIC
};

@Component({
  name: 'Tv',
  components: {
    PageSpinner,
  },
})
export default class Tv extends Vue {
  private PROJECT_TYPES = ProjectTypes;
  private token: string = tokenExtractor.extract();

  private get cookingOrders() {
    return this.actualOrders
      .filter(({ isDone }: TakeAway) => !isDone)
      .sort((firstOrder: TakeAway, secondOrder: TakeAway) => {
        return firstOrder.systemOrderNumber - secondOrder.systemOrderNumber;
      });
  }

  private get doneOrders() {
    return this.actualOrders
      .filter(({ isDone }: TakeAway) => isDone)
      .sort((firstOrder: TakeAway, secondOrder: TakeAway) => {
        return firstOrder.systemOrderNumber - secondOrder.systemOrderNumber;
      });
  }

  private get tvAdImage() {
    if (ProjectTypes.GRILL_KEBAB === this.projectType) {
      return require('./assets/images/tv/tv-ad-gk.png');
    } else if (ProjectTypes.DONER_TURKISH_GRILL === this.projectType) {
      return require('./assets/images/tv/tv-ad-dtg.png');
    }

    return require('./assets/images/tv/tv-ad-default.png');
  }

  private get logoImage() {
    if (ProjectTypes.GRILL_KEBAB === this.projectType) {
      return require('./assets/images/tv/logo-gk.png');
    } else if (ProjectTypes.DONER_TURKISH_GRILL === this.projectType) {
      return require('./assets/images/tv/logo-dtg.png');
    } else if (ProjectTypes.GRILL_MANERO === this.projectType) {
      return require('./assets/images/tv/logo_grillmanero.jpg');
    } else if (ProjectTypes.VKUSNIY_KEBAB === this.projectType) {
      return require('./assets/images/tv/logo-vkusniy-kebab.png');
    } else if (ProjectTypes.KEBAB_BROTHERS === this.projectType) {
      return require('./assets/images/tv/logo-kebab-brothers.png');
    } else if (ProjectTypes.DEENERS_KEBAB === this.projectType) {
      return require('./assets/images/tv/logo-deeners-kebab.png');
    } else if (ProjectTypes.MISTER_DONER === this.projectType) {
      return require('./assets/images/tv/logo-mister-doner.png');
    } else if (ProjectTypes.SONIC === this.projectType) {
      return require('./assets/images/tv/logo-sonic.png');
    }

    return require('./assets/images/tv/logo-default.png');
  }

  private get projectType(): ProjectTypes {
    const type: ProjectTypes = <ProjectTypes> PLACE_IDS[this.token];

    return type || ProjectTypes.DEFAULT;
  }

  @State('actualOrders', {
    namespace: 'tv',
  })
  private actualOrders!: TakeAway[];

  @State('isActualOrdersFetching', {
    namespace: 'tv',
  })
  private isActualOrdersFetching!: boolean;

  @State('isSocketConnected')
  isSocketConnected!: boolean;

  @Watch('isSocketConnected', {
    immediate: true,
  })
  onIsSocketConnectedChanged(isSocketConnected: boolean) {
    if (isSocketConnected) {
      setTimeout(
        () => {
          this.$socket.emit('join', this.token);
        },
        1000,
      );
    }
  }

  private async created() {
    this.fetchActualOrders(this.token);
    this.fetchLastEventIdByToken(this.token);
  }

  private openFullscreen() {
    const element: any = document.documentElement;
    const openFullScreenFunction = element.requestFullscreen || element.webkitRequestFullscreen;

    openFullScreenFunction.call(element);
  }

  @Action('fetchActualOrders', {
    namespace: 'tv',
  })
  private fetchActualOrders!: ActionMethod;

  @Action('fetchLastEventIdByToken', {
    namespace: 'eventLog',
  })
  private fetchLastEventIdByToken!: ActionMethod;
}
